/**
 * Businesses READ endpoint — wire types for the businesses index grid.
 * Plain RLS-scoped read: the Hono handler pages the `business_index` view past
 * PostgREST's 1,000-row cap with a keyset cursor (fetchAllKeyset) through the
 * per-request user client, so org RLS authorizes.
 *
 * No query params: the endpoint returns the COMPLETE org index; search, the
 * filter document and sorting run client-side over the complete set. Heavy
 * detail stays on the by-code read. Template: placesReads.ts.
 *
 * Shared by the API handler (response construction) and the web index hook
 * (unwrap target) so the two cannot drift.
 *
 * Also the by-code DETAIL read, the write endpoints' responses and the
 * delete guard (`apps/api/src/routes/people/businesses.ts`; request schemas in
 * ./businesses.ts).
 */
/** The keys of {@link BusinessDeleteBlockers}, in display order. */
export const BUSINESS_DELETE_BLOCKER_KEYS = [
    "ledger_transactions",
    "expenses",
    "ap_bills",
    "ar_invoices",
    "vat_settlements",
    "purchase_orders",
    "assets",
    "contracts",
    "time_entries",
    "timesheets",
    "memos",
    "linked_people",
    "person_connections",
];
/** True when any count forbids the delete — the DELETE route's 409 test and the danger zone's disabled state. */
export function isBusinessInUse(blockers) {
    return BUSINESS_DELETE_BLOCKER_KEYS.some((key) => blockers[key] > 0);
}
//# sourceMappingURL=businessesReads.js.map